export default __webpack_public_path__ + "static/media/34.0b6cb03e.png";